__turbopack_context__.v({
  "copyActionElement": "vW0_FW_copyActionElement",
  "copyLink": "vW0_FW_copyLink",
  "desktopOnly": "vW0_FW_desktopOnly",
  "flex": "vW0_FW_flex",
  "linkContent": "vW0_FW_linkContent",
  "qr": "vW0_FW_qr",
  "root": "vW0_FW_root",
  "stacked": "vW0_FW_stacked",
});
